module.exports = __webpack_public_path__ + "img/logo-footer.c0a38448.svg";